// Модальное окно добавления марки каната оттяжки внутри AddTensionsMeasurements
// AddTensionsMeasurementsMarks.jsx
import React, { useState } from 'react';
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CForm,
  CRow,
  CCol,
  CFormLabel,
  CFormInput,
  CFormTextarea,
  CInputGroup,
  CFormSelect
} from '@coreui/react';
import { cilPlus } from '@coreui/icons';
import CIcon from '@coreui/icons-react';

const AddTensionsMeasurementsMarks = ({ visible, onClose, onSave }) => {
  const [direction, setDirection] = useState('');
  const [directionType, setDirectionType] = useState('Верхнее');
  const [rope, setRope] = useState('');
  const [actualDiameter, setActualDiameter] = useState('');
  const [temperature, setTemperature] = useState('');
  const [foundationRollerMark, setFoundationRollerMark] = useState('');
  const [foundationNodeOffset, setFoundationNodeOffset] = useState('');
  const [rollerDifference, setRollerDifference] = useState('');
  const [tensions, setTensions] = useState(['', '', '', '', '']);
  const [waveTimes, setWaveTimes] = useState(['', '', '', '', '']);

  const handleSave = () => {
    const measurementData = {
      direction,
      directionType,
      rope,
      actualDiameter,
      temperature,
      foundationRollerMark,
      foundationNodeOffset,
      rollerDifference,
      tensions,
      waveTimes
    };
    onSave(measurementData);
    resetForm();
    onClose();
  };

  const resetForm = () => {
    setDirection('');
    setDirectionType('Верхнее');
    setRope('');
    setActualDiameter('');
    setTemperature('');
    setFoundationRollerMark('');
    setFoundationNodeOffset('');
    setRollerDifference('');
    setTensions(['', '', '', '', '']);
    setWaveTimes(['', '', '', '', '']);
  };

  const handleTensionChange = (index, value) => {
    const newTensions = [...tensions];
    newTensions[index] = value;
    setTensions(newTensions);
  };

  const handleWaveTimeChange = (index, value) => {
    const newWaveTimes = [...waveTimes];
    newWaveTimes[index] = value;
    setWaveTimes(newWaveTimes);
  };

  return (
    <CModal visible={visible} onClose={onClose} size="lg">
      <CModalHeader>
        <CModalTitle>Добавить измерение</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CForm>
          <CRow className="mb-3 align-items-end">
            <CCol md="4">
              <CFormLabel htmlFor="direction">Направление</CFormLabel>
            </CCol>
            <CCol md="4">
              <CFormInput
                type="text"
                id="direction"
                value={direction}
                onChange={(e) => setDirection(e.target.value)}
              />
            </CCol>
            <CCol md="4">
              <CFormSelect
                value={directionType}
                onChange={(e) => setDirectionType(e.target.value)}
              >
                <option value="Верхнее">Верхнее</option>
                <option value="Нижнее">Нижнее</option>
                <option value="Левое">Левое</option>
                <option value="Правое">Правое</option>
              </CFormSelect>
            </CCol>
          </CRow>

          <CRow className="mb-3">
            <CCol md="4">
              <CFormLabel>Канат</CFormLabel>
            </CCol>
            <CCol md="8">
              <CInputGroup>
                <CFormTextarea
                  value={rope}
                  onChange={(e) => setRope(e.target.value)}
                  placeholder="Введите канат"
                  rows={1}
                />
                <CButton
                  type="button"
                  color="primary"
                  variant="outline"
                  onClick={() => console.log('Открыть модальное окно выбора')}
                  style={{ maxHeight: '38px' }}
                >
                  <CIcon icon={cilPlus} />
                </CButton>
              </CInputGroup>
            </CCol>
          </CRow>

          <CRow className="mb-3 align-items-end">
            <CCol md="6">
              <CFormLabel htmlFor="actualDiameter">Фактический диаметр каната, мм</CFormLabel>
            </CCol>
            <CCol md="2">
              <CFormInput
                type="text"
                id="actualDiameter"
                value={actualDiameter}
                onChange={(e) => setActualDiameter(e.target.value)}
              />
            </CCol>
            <CCol md="2">
              <CFormLabel htmlFor="temperature" className="mb-0">Температура, °C</CFormLabel>
            </CCol>
            <CCol md="2">
              <CFormInput
                type="text"
                id="temperature"
                value={temperature}
                onChange={(e) => setTemperature(e.target.value)}
              />
            </CCol>
          </CRow>

          <CRow className="mb-3">
            <CCol md="10">
              <CFormLabel htmlFor="foundationRollerMark">Отметка валика оттяжки анкерного фундамента, м</CFormLabel>
            </CCol>
            <CCol md="2">
              <CFormInput
                type="text"
                id="foundationRollerMark"
                value={foundationRollerMark}
                onChange={(e) => setFoundationRollerMark(e.target.value)}
              />
            </CCol>
          </CRow>

          <CRow className="mb-3">
            <CCol md="10">
              <CFormLabel htmlFor="foundationNodeOffset">Относ узла анкерного фундамента от внешней плоскости пояса - L1 или L2, м</CFormLabel>
            </CCol>
            <CCol md="2">
              <CFormInput
                type="text"
                id="foundationNodeOffset"
                value={foundationNodeOffset}
                onChange={(e) => setFoundationNodeOffset(e.target.value)}
              />
            </CCol>
          </CRow>

          <CRow className="mb-3">
            <CCol md="10">
              <CFormLabel htmlFor="rollerDifference">Разница между валиками оттяжек - A, B или C, м</CFormLabel>
            </CCol>
            <CCol md="2">
              <CFormInput
                type="text"
                id="rollerDifference"
                value={rollerDifference}
                onChange={(e) => setRollerDifference(e.target.value)}
              />
            </CCol>
          </CRow>

          <div className="mb-3">
            <CFormLabel>Натяжение оттяжки, тс</CFormLabel>
            <CRow>
              {[0, 1, 2, 3, 4].map((index) => (
                <CCol key={index} md={2} className="mb-2">
                  <CFormInput
                    type="text"
                    value={tensions[index]}
                    onChange={(e) => handleTensionChange(index, e.target.value)}
                  />
                </CCol>
              ))}
            </CRow>
          </div>

          <div className="mb-3">
            <CFormLabel>Время волны, сек</CFormLabel>
            <CRow>
              {[0, 1, 2, 3, 4].map((index) => (
                <CCol key={index} md={2} className="mb-2">
                  <CFormInput
                    type="text"
                    value={waveTimes[index]}
                    onChange={(e) => handleWaveTimeChange(index, e.target.value)}
                  />
                </CCol>
              ))}
            </CRow>
          </div>
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Отмена
        </CButton>
        <CButton color="primary" onClick={handleSave}>
          Сохранить
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default AddTensionsMeasurementsMarks;